import { Stack, Typography } from "@mui/material";
import moment from "moment";
import GlobalConst from "../../../Core/Utils/Constants/globals";

export interface TableCellDate2LinesProps {
  date: Date;
}

const TableCellDate2Lines: React.FC<TableCellDate2LinesProps> = ({ date }) => {
  let dateParse = moment(date);
  return (
    <Stack direction="row" spacing={1.5}>
      <Stack flex={1} overflow="hidden">
        <Typography fontWeight={500} sx={(theme) => ({ ...theme.helpers(theme).ellipsis })}>
          {dateParse.format(GlobalConst.MOMENT_DATE_FORMAT_DATENOHOURS)}
        </Typography>
        <Typography color="text.secondary" variant="body2" sx={(theme) => ({ ...theme.helpers(theme).ellipsis })}>
          {dateParse.format(GlobalConst.MOMENT_DATE_FORMAT_HOURS)}
        </Typography>
      </Stack>
    </Stack>
  );
};

export default TableCellDate2Lines;
